enum SupportedContext {
  PRODUCT = 'product',
  CONTENT = 'content',
  ALL = 'all',
  CATEGORY = 'category',
  EXTERNAL = 'external',
}

export default SupportedContext;
